import React, { Component, Fragment } from 'react'
import { Route, Switch, NavLink } from "react-router-dom";
import { connect } from 'react-redux'
import { loadFavorite } from '../../redux/marks/actions';


import MarksListing from './MarksListing/MarksListing'
import MarksDetails from './MarksDetails/MarksDetails'


import moment from 'moment';

class Marks extends Component {

    _isMounted = false;
    state = {
        now :  moment()
    }

    componentDidMount(){
        this._isMounted = true;
        this.refresh = setInterval(()=>{
            if (this._isMounted) {
                this.setState({
                    now :  moment()
                })
            }
        }, 3000);
        this.props.loadFavorite();
    }

    componentWillUnmount() {
        this._isMounted = false;
      }

  
    render() {
        const expirationdate = moment.unix(this.props.expiration);
        const accountdisabled = expirationdate<=this.state.now;
        if(accountdisabled){
            return(<div><h1>Your subscription</h1><p><strong>{this.props.termes.application.membreBannerTextHasExpired} {expirationdate.fromNow() }</strong></p><NavLink  style={{marginBottom : "80px"}} className="buttonbig"  to="/account/">{this.props.termes.application.membreBannerBTNHasExpired}</NavLink></div>)
        }

        return(
           <Fragment>
            
            <Switch>
              <Route path="/marks/:markid" component={MarksDetails} />
              <Route path="/marks" component={MarksListing} />
            </Switch>
            </Fragment>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
      expiration:state.auth.userinfos.expirationtimestamp,
      termes: state.settings.termes
    }
  };

export default connect(mapStateToProps,{loadFavorite})(Marks);
